import { Directive, ElementRef, inject } from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';

@Directive({
  selector: '[appInlineConfirmationConfirm]',
  standalone: true,
  host: {
    "class": "inline-confirmation__operator"
  }
})
export class InlineConfirmationConfirmDirective {
  private readonly _host: ElementRef<HTMLElement> | null = inject(ElementRef<HTMLElement>, { optional: true });

  private readonly _confirm$: Subject<PointerEvent> = new Subject<PointerEvent>();

  public readonly confirm$: Observable<PointerEvent> = this._confirm$.asObservable();

  constructor () {
    if (this._host?.nativeElement) {
      fromEvent<PointerEvent>(this._host.nativeElement, "click")
        .subscribe((pointerEvent: PointerEvent) => this._confirm$.next(pointerEvent));
    }
  }
}
